<!-- Hidden input -->
<div [formGroup]="formGroup">
  <input
    autoFocus
    *ngIf="fields.fieldType === 'hidden'"
    type="hidden"
    [formControlName]="fields.fieldName"
  />

  <div *ngIf="fields.fieldType !== 'hidden'" class="w-full py-1 px-2">
    <label
      [ngClass]="{ required: fields.isRequired == true }"
      class="block text-2sm font-semibold text-gray-700 dark:text-gray-300 mb-1"
    >
      {{ formatDisplayName(fields.displayName) }}
    </label>

    <div class="flex items-center justify-between gap-3 bg-transparent">
      <span class="text-2sm text-gray-500 dark:text-gray-400 leading-snug">
        {{ fields.placeholder }}
      </span>
      <div class="flex items-center gap-2 shrink-0">
        <div class="switch switch-sm">
          <input
            type="checkbox"
            [checked]="isActive"
            [attr.name]="fields.fieldName"
            (change)="onSwitchChange($event)"
          />
        </div>
        <span
          class="text-2sm font-medium text-gray-800 dark:text-gray-200 min-w-[52px]"
        >
          {{
            isActive
              ? "Active"
              : "Inactive"
          }}
        </span>
      </div>
    </div>
  </div>
</div>
